import styles from './StepsList.module.css';
import { Children, ReactNode } from 'react';

type Props = {
  children?: ReactNode;
};

export function StepsList({ children }: Props) {
  const childArray = Children.toArray(children);
  return (
    <ol className={styles.root}>
      {childArray.map((c, idx) => (
        <li key={idx} className={styles.item}>
          <div className={styles.content}>{c}</div>
        </li>
      ))}
    </ol>
  );
}
